import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { ExistingUser } from "@/components/signup/site-activation/components/existing-user/existing-user";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils/logos/rovo-dev-agents-logo";

import { SignupFormWithPaymentSwitcher } from "../../components/payment/signup-form-with-payment-switcher";
import { PrivacyPolicy } from "../../components/privacy-policy";
import { WelcomeBackHeading } from "../../components/welcome-back-heading";

export const LoggedInDevAIFreeExistingSitesUser = () => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedExistingUserSubHeader",
        defaultMessage: "Join the free beta program"
    });

    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <SiteActivation
                ExistingUser={
                    <SignupFormWithPaymentSwitcher
                        header={
                            <>
                                <h1 css={headerCss}>
                                    <WelcomeBackHeading />
                                </h1>
                                <p css={headerCss}>{subHeaderText}</p>
                            </>
                        }
                    >
                        <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
                    </SignupFormWithPaymentSwitcher>
                }
                WeekOneUser={null}
                ManagedUser={null}
            />
        </SignupBackgroundLayout>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
